module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bp-admin-skin/bin/fonts/glyphicons-halflings-regular.svg
 ** module id = 11
 ** module chunks = 0
 **/